export default __webpack_public_path__ + "static/media/PROCESSMETHOD_PRINTING_MJF.4633b9f0.png";